'use strict';

import 'document-register-element';
import resizeStore from '../resize/resize.store';



export class ViewContent extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._height = 0;
    this.onResize = e => this._onResize(e);
  }
  connectedCallback() {
    this._inner = this.querySelector('.view-content-inner');
    if (!this._inner) throw('Где контент? (view-content)');

    this._onResize();
    resizeStore.eventEmitter.subscribe(this.onResize);
  }
  disconnectedCallback() {
    resizeStore.eventEmitter.unsubscribe(this.onResize);
  }
  _onResize() {
    const bounds = this._inner.getBoundingClientRect();
    const height = Math.ceil(bounds.height / 101) * 101 - 1;

    if (height !== this._height) {
      this.style.height = `${height}px`;
      this._height = height;
    }
  }
}


window.customElements.define('view-content', ViewContent);